import Vue from  "vue";
import paywallBanner from './paywall-banner';

document.addEventListener("DOMContentLoaded", () => {
  const applyPreviewCutoff = document.querySelector('[data-preview-cutoff]');
  const bannerTrayEl = document.querySelector('[data-banner-tray]');
  const footerOverlayEl = document.querySelector('[data-footer-overlay]');
  const paywallMountEl = document.querySelector('[data-paywall-banner]');

  if (applyPreviewCutoff && bannerTrayEl && footerOverlayEl && paywallMountEl) {
    new Vue({
      el: paywallMountEl,
      components: {
        'paywall-banner': paywallBanner
      }
    });
  }
});
